import './ccf-quick-replies-icon.module.scss';
import { SvgIcon, SvgIconProps } from '@mui/material';


/**
 * component used to display quick replies icon
 * @param props - SvgIconProps
 * @example - <CcfQuickRepliesIcon />
 * @returns SVG of quick replies icon
 */
export function CcfQuickRepliesIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <g id="ic_quick_replies" width="22" height="25" viewBox="0 0 22 25">
        <g id="ic_app_quickreplies" transform="translate(-15.686 1.161)">
          <path id="lightning" d="M20.8,8.8H12V0L3.2,13.2H12V22Z" transform="translate(14.686)"/>
        </g>
      </g>    
    </SvgIcon>
  );
}

export default CcfQuickRepliesIcon;
